import { __assign, __rest } from "tslib";
import React from 'react';
import { getBaseProps } from '../internal/base-component';
import clsx from 'clsx';
import styles from './styles.css.js';
import { useTelemetry } from '../internal/hooks/use-telemetry';
var Badge = function Badge(_a) {
    var _b = _a.color, color = _b === void 0 ? 'grey' : _b, children = _a.children, rest = __rest(_a, ["color", "children"]);
    useTelemetry('Badge');
    var baseProps = getBaseProps(rest);
    var className = clsx(baseProps.className, styles.badge, styles["badge-color-" + color]);
    return (React.createElement("span", __assign({}, baseProps, { className: className }), children));
};
export default Badge;
//# sourceMappingURL=index.js.map